import { useNavigate } from "react-router-dom";
import styles from "../../assets/stylesheets/Assistant.module.scss";
import { useState } from "react";
import { getAssistantInfoForReport } from "../../utils/api/endpoints/business/assistant";
import usePageTitle from "../../utils/hooks/usePageTitle";
import useReports from "../../utils/hooks/reports/useReports";

const PatchAssistant = () => {
  const navigate = useNavigate();
  const [response, setResponse] = useState<string | undefined>();
  const [reportId, setReportId] = useState<string | undefined>();
  const { reports } = useReports({ limit: 5, page: 1 });

  usePageTitle("Patch Assistant");

  const generateResponse = async () => {
    if (reportId !== undefined) {
      const response = await getAssistantInfoForReport(reportId);
      setResponse(response);
    }
  };

  return (
    <section className={styles.container}>
      <div className={styles.headerContainer}>
        <h1 className={styles.h1}>Patch Assistance</h1>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/dashboard/assistant/chat-assistant")}
        >
          Ask Other Questions
        </button>
      </div>

      {response && (
        <div className={styles.answerContainer}>
          <h2 className={styles.h2}>Anwser:</h2>
          <pre className={styles.answerCode}>{response}</pre>
        </div>
      )}

      <div className={styles.inputWrapper}>
        <select
          value={reportId}
          className={styles.questionInpt}
          onChange={e => setReportId(e.target.value)}
        >
          <option value="">Select report for patch assistance</option>
          {reports.map(
            (report, index) =>
              report && (
                <option key={index} value={report.id}>
                  {report.id} - {report.title}
                </option>
              )
          )}
        </select>

        <button
          className={styles.getAnsBtn}
          onClick={generateResponse}
          disabled={reportId === undefined || reportId === ""}
        >
          Get More Info
        </button>
      </div>

      <pre>
        If you've got more questions, you can always reach out to us at{" "}
        <a href="mailto://support@capturethebug.xyz">
          support@capturethebug.xyz
        </a>{" "}
      </pre>
    </section>
  );
};

export default PatchAssistant;
